import React, { useState } from "react";
import { sendContact } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    company: "",
  });
  const [status, setStatus] = useState({ type: "idle", message: "" });

  function validateEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (status.type === "loading") return; // prevent double submit
    setStatus({ type: "idle", message: "" });

    if (form.company) {
      setStatus({ type: "error", message: "Submission blocked." });
      return;
    }

    if (!form.name || !form.email || !form.phone || !form.message) {
      setStatus({ type: "error", message: "Please fill in all fields." });
      return;
    }
    if (!validateEmail(form.email)) {
      setStatus({
        type: "error",
        message: "Please enter a valid email address.",
      });
      return;
    }

    try {
      setStatus({ type: "loading", message: "" });
      await sendContact(
        {
          name: form.name.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
          message: form.message.trim(),
        },
        { timeoutMs: 10000 },
      );
      setStatus({
        type: "success",
        message: "Thank you. We will contact you shortly.",
      });
      setForm({ name: "", email: "", phone: "", message: "", company: "" });
    } catch (err) {
      const msg =
        err?.name === "AbortError" ||
        /timed out|aborted/i.test(String(err?.message || ""))
          ? "Request timed out. Please try again."
          : err?.message || "Send failed";
      setStatus({ type: "error", message: msg });
    }
  }

  return (
    <div style={{ backgroundColor: "#0a0a0a", color: "#fff" }}>
      <section
        style={{
          padding: "64px 16px",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          background:
            "linear-gradient(180deg, rgba(255,215,0,0.08) 0%, rgba(10,10,10,0) 60%)",
        }}
      >
        <h1 style={{ fontSize: 42, margin: 0, letterSpacing: 0.5 }}>
          Contact Us
        </h1>
        <p style={{ marginTop: 12, color: "#d1d1d1" }}>
          We are here to assist you 24/7
        </p>
      </section>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "32px 16px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 920,
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 24,
          }}
        >
          <div
            style={{
              backgroundColor: "#0f0f0f",
              border: "1px solid rgba(255,215,0,0.18)",
              borderRadius: 16,
              padding: 24,
              boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
            }}
          >
            <form onSubmit={onSubmit} noValidate>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 16,
                }}
              >
                <div style={{ gridColumn: "1 / -1" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 8,
                      color: "#d7c36a",
                    }}
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={onChange}
                    required
                    placeholder="John Doe"
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 8,
                      color: "#d7c36a",
                    }}
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={onChange}
                    required
                    placeholder="you@example.com"
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 8,
                      color: "#d7c36a",
                    }}
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={onChange}
                    required
                    placeholder="+49 160 0000000"
                    style={inputStyle}
                  />
                </div>
                <div style={{ gridColumn: "1 / -1" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 8,
                      color: "#d7c36a",
                    }}
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={onChange}
                    required
                    placeholder="How can we help you?"
                    rows={6}
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                </div>

                <div style={{ display: "none" }} aria-hidden="true">
                  <label>Company</label>
                  <input
                    type="text"
                    name="company"
                    value={form.company}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <button
                  type="submit"
                  disabled={status.type === "loading"}
                  style={{
                    background: "linear-gradient(90deg, #bfa24c, #e8d88a)",
                    color: "#0a0a0a",
                    border: "none",
                    padding: "12px 20px",
                    borderRadius: 12,
                    fontWeight: 700,
                    letterSpacing: 0.3,
                  }}
                >
                  {status.type === "loading" ? "Sending..." : "Send Message"}
                </button>
                {status.message && (
                  <span
                    style={{
                      color: status.type === "success" ? "#a0e0a0" : "#ff9c9c",
                      fontSize: 14,
                    }}
                  >
                    {status.message}
                  </span>
                )}
              </div>
            </form>
          </div>

          <div
            style={{
              backgroundColor: "#0f0f0f",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: 24,
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: 12, color: "#d7c36a" }}>
              Fahrlux Hanau
            </h3>

            <div style={{ color: "#d1d1d1", fontSize: 14, lineHeight: 1.8 }}>
              <div>Email: info@fahrlux-hanau.de</div>
              <div>Service: 24/7</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid rgba(215, 195, 106, 0.35)",
  backgroundColor: "#0a0a0a",
  color: "#fff",
  outline: "none",
};
